


import { Component, Vue } from "vue-property-decorator";

@Component
export default class FormFieldGroup extends Vue {}
